import { Component, input } from '@angular/core';

@Component({
  selector: 'app-page-hero',
  imports: [],
  templateUrl: './page-hero.component.html',
  styleUrl: './page-hero.component.css',
})
export class PageHeroComponent {
  badge = input<string>();
  title = input<string>();
  highlight = input<string | undefined>();
  descriptionLine1 = input<string>();
  descriptionLine2 = input<string>();
  bgImage = input<string>('/images/bg.png');

}
